import React from "react";
import { useState, useMemo, useEffect } from "react";
import CustomTable from "../CustomTable";
import Loading from "../utils/Loading";
import RecordCount from "../utils/RecordCount";

const OviMailDetails = (props) => {
  const [data, setData] = useState(props.mailDetails || null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!data && props.oviMailDetailsPath) {
      const fetchData = async () => {
        try {
          const response = await fetch(props.oviMailDetailsPath, { headers: { Accept: "application/json" } });
          if (response.status == "404") {
            setData([]);
          } else if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          } else {
            const fetchedData = await response.json();
            setData(fetchedData);
          }
        } catch (error) {
          console.log("Error fetching data: ", error);
        } finally {
          setIsLoading(false);
        }
      };
      if (!data || data.length === 0) {
        fetchData();
      } else {
        setIsLoading(false);
      }
    } else {
      setIsLoading(false);
    }
  }, []);

  const columns = useMemo(
    () => [
      {
        Header: "Sent At",
        accessor: "sent_at_date",
        filter: "fuzzyText",
      },
      {
        Header: "Email",
        accessor: "email",
        filter: "fuzzyText",
        Cell: (tableProps) => (
          <div>
            <small className="text-muted">{tableProps.row.original.email}</small>
          </div>
        )
      },
      {
        Header: "340B ID",
        accessor: "id_340b",
        filter: "fuzzyText",
        Cell: tableProps => <a href={`/entities/340bid/${tableProps.row.original.id_340b}`}>{tableProps.value}</a>
      },
      {
        Header: "PID",
        accessor: "pid",
        Cell: (tableProps) => {
          return (
            <div className={`badge text-uppercase ${tableProps.row.original.pid_check ? "bg-success" : "bg-danger"}`}>{tableProps.row.original.pid}</div>
          );
        },
      },
      {
        Header: "Pharmacy",
        accessor: (row) => `${row.pharmacy_name} ${row.pharmacy_address}`,
        filter: "fuzzyText",
        Cell: (tableProps) => (
          <div className="text-nowrap me-3">
            <b>{tableProps.row.original.pharmacy_name}</b>
            <br />
            <small className="text-muted">{tableProps.row.original.pharmacy_address}</small>
          </div>
        ),
      },
      {
        Header: "Network",
        accessor: "network",
        filter: "fuzzyText",
        Cell: (tableProps) => (
          <span className="badge bg-secondary">{tableProps.row.original.network}</span>
        ),
      },
      {
        Header: "Manufacturer",
        accessor: "manufacturer",
        filter: "fuzzyText",
      },
      {
        Header: "Category",
        accessor: "category",
        filter: "fuzzyText",
      },
      {
        Header: "Accelerated?",
        accessor: "accelerated",
        filter: "fuzzyText",
      }
    ],
    [],
  );

  return (
    <React.Fragment>
      {isLoading ? (
        <Loading />
      ) : data ? (
        <>
          <RecordCount record_count={data.length} />
          {data.length > 0 ? <CustomTable columns={props.columns || columns} data={data} /> : null}
        </>
      ) : null}
    </React.Fragment>
  );
};

export default OviMailDetails;
